import React from 'react';
import { ArrowLeft, Shield, FileText, AlertTriangle, Building2, Users, ExternalLink, Mail, Phone } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { logoUrl } from '../mockData';

const TrasparenzaReclami = () => {
  const navigate = useNavigate();

  const impreseMandanti = [
    { nome: 'ASSIMOCO S.P.A.', tipo: 'Mandato diretto' },
    { nome: 'ASSIMOCO VITA S.P.A.', tipo: 'Mandato diretto' },
    { nome: 'GROUPAMA ASSICURAZIONI S.P.A.', tipo: 'Mandato diretto' },
    { nome: 'SLP - TUTELA LEGALE', tipo: 'Mandato diretto' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate('/')}
              className="flex items-center space-x-2 text-[#2B7A9F] hover:text-[#3AAFA9] transition-colors duration-300"
            >
              <ArrowLeft size={20} />
              <span className="font-medium">Torna alla Home</span>
            </button>
            <img src={logoUrl} alt="Assietica" className="h-12 w-auto" />
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#2B7A9F] to-[#17536B] text-white py-12 sm:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-16 h-16 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center mx-auto mb-6">
            <Shield className="text-white" size={32} />
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold mb-4">
            Trasparenza, Reclami e Risoluzione Controversie
          </h1>
          <p className="text-lg text-white/90 max-w-2xl mx-auto">
            In conformita alle disposizioni del Codice delle Assicurazioni Private e ai Regolamenti IVASS vigenti, 
            Assietica Soc. Coop. Societa Benefit impronta i propri rapporti con i clienti alla massima trasparenza e correttezza.
          </p>
        </div>
      </div>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="space-y-10">
          
          {/* Sezione 1: Informazioni sull'Intermediario */}
          <section className="bg-white rounded-xl shadow-sm p-6 sm:p-8">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-[#2B7A9F]/10 rounded-lg flex items-center justify-center">
                <Building2 className="text-[#2B7A9F]" size={20} />
              </div>
              <h2 className="text-xl font-bold text-[#2B7A9F]">1. Informazioni sull'Intermediario</h2>
            </div>
            
            <p className="text-gray-700 mb-4">
              <strong>Assietica Soc. Coop. Societa Benefit</strong> e un intermediario assicurativo iscritto al RUI 
              (Registro Unico degli Intermediari) con numero <strong>A000480096</strong> — Sezione A (Agenti) — 
              data di iscrizione <strong>07/02/2014</strong> ed e soggetto alla vigilanza dell'IVASS.
              L'iscrizione può essere verificata sul{' '}
              <a href="https://servizi.ivass.it/RuirPubblica/" target="_blank" rel="noopener noreferrer" className="text-[#2B7A9F] underline">Registro pubblico IVASS</a>.
            </p>
            
            <div className="bg-gray-50 rounded-lg p-4 space-y-2 text-sm">
              <p><strong>Sede Legale:</strong> Viale Antonio Gramsci 8/G, 08015 Macomer (NU)</p>
              <p><strong>P.IVA / C.F.:</strong> 01435480916</p>
              <p>
                <strong>Email PEC:</strong>{' '}
                <a href="mailto:cdsp@pec.confcooperative.it" className="text-[#2B7A9F] hover:underline">
                  cdsp@pec.confcooperative.it
                </a>
              </p>
              <p>
                <strong>Email Ordinaria:</strong>{' '}
                <a href="mailto:agenzia@assietica.it" className="text-[#2B7A9F] hover:underline">
                  agenzia@assietica.it
                </a>
              </p>
            </div>
          </section>

          {/* Sezione 2: Gestione dei Reclami */}
          <section className="bg-white rounded-xl shadow-sm p-6 sm:p-8">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-[#E67E22]/10 rounded-lg flex items-center justify-center">
                <FileText className="text-[#E67E22]" size={20} />
              </div>
              <h2 className="text-xl font-bold text-[#E67E22]">2. Gestione dei Reclami</h2>
            </div>
            
            <p className="text-gray-700 mb-4">
              Qualora insorgesse un contrasto relativo alla gestione del rapporto contrattuale o a un servizio assicurativo, 
              il cliente ha la facolta di presentare un reclamo per iscritto direttamente all'intermediario o all'Impresa di Assicurazione.
            </p>
            
            <h3 className="font-semibold text-gray-800 mb-3">Come presentare un reclamo ad Assietica:</h3>
            <p className="text-gray-700 mb-3">Il reclamo puo essere inviato tramite:</p>
            
            <div className="bg-[#E67E22]/5 border border-[#E67E22]/20 rounded-lg p-4 space-y-2 text-sm">
              <p className="flex items-center">
                <Mail size={16} className="text-[#E67E22] mr-2" />
                <strong>Email:</strong>
                <a href="mailto:agenzia@assietica.it" className="text-[#2B7A9F] hover:underline ml-2">
                  agenzia@assietica.it
                </a>
              </p>
              <p className="flex items-center">
                <Mail size={16} className="text-[#E67E22] mr-2" />
                <strong>PEC:</strong>
                <a href="mailto:cdsp@pec.confcooperative.it" className="text-[#2B7A9F] hover:underline ml-2">
                  cdsp@pec.confcooperative.it
                </a>
              </p>
              <p className="flex items-center">
                <Building2 size={16} className="text-[#E67E22] mr-2" />
                <strong>Posta ordinaria:</strong>
                <span className="ml-2">Viale Antonio Gramsci 8/G, 08015 Macomer (NU)</span>
              </p>
            </div>
            
            <p className="text-gray-600 text-sm mt-4 italic">
              L'intermediario e tenuto a fornire riscontro entro il termine massimo previsto dalla normativa vigente.
            </p>
          </section>

          {/* Sezione 3: Arbitro Assicurativo */}
          <section className="bg-white rounded-xl shadow-sm p-6 sm:p-8 border-l-4 border-[#5FB76E]">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-[#5FB76E]/10 rounded-lg flex items-center justify-center">
                <Shield className="text-[#5FB76E]" size={20} />
              </div>
              <div>
                <h2 className="text-xl font-bold text-[#5FB76E]">3. Arbitro Assicurativo</h2>
                <p className="text-sm text-gray-500">Rif. Provvedimento IVASS n. 163/2025</p>
              </div>
            </div>
            
            <p className="text-gray-700 mb-4">
              Ai sensi del Provvedimento IVASS n. 163/2025, si informa che <strong>dal 15 gennaio 2026</strong> il contraente ha la facolta di:
            </p>
            
            <ul className="space-y-4 text-gray-700">
              <li className="flex items-start">
                <span className="w-6 h-6 bg-[#5FB76E] text-white rounded-full flex items-center justify-center text-sm font-bold mr-3 mt-0.5 flex-shrink-0">1</span>
                <span>
                  <strong>Avvalersi di sistemi alternativi di risoluzione delle controversie (ADR)</strong> indicati nei DIP aggiuntivi 
                  consegnati in fase contrattuale (es. Mediazione, Negoziazione Assistita).
                </span>
              </li>
              <li className="flex items-start">
                <span className="w-6 h-6 bg-[#5FB76E] text-white rounded-full flex items-center justify-center text-sm font-bold mr-3 mt-0.5 flex-shrink-0">2</span>
                <div>
                  <strong>Presentare ricorso all'Arbitro Assicurativo</strong> qualora non soddisfatto dall'esito del reclamo 
                  o in assenza di riscontro entro i termini di legge.
                  <div className="mt-2 bg-[#5FB76E]/10 rounded-lg p-3">
                    <p className="text-sm">
                      Il ricorso e presentabile tramite il portale:{' '}
                      <a 
                        href="https://www.arbitroassicurativo.org" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-[#5FB76E] font-semibold hover:underline inline-flex items-center"
                      >
                        www.arbitroassicurativo.org
                        <ExternalLink size={14} className="ml-1" />
                      </a>
                    </p>
                    <p className="text-xs text-gray-600 mt-1">
                      Sul sito sono consultabili i requisiti di ammissibilita e le modalita di presentazione.
                    </p>
                  </div>
                </div>
              </li>
              <li className="flex items-start">
                <span className="w-6 h-6 bg-[#5FB76E] text-white rounded-full flex items-center justify-center text-sm font-bold mr-3 mt-0.5 flex-shrink-0">3</span>
                <span>
                  <strong>Presentare ricorso alla rete FIN-NET</strong> - Sistema di risoluzione stragiudiziale delle controversie 
                  della rete transfrontaliera, cui l'intermediario aderisce ai sensi del Decreto MIMIT 6 novembre 2024, n. 215.
                </span>
              </li>
            </ul>
          </section>

          {/* Sezione 4: Elenco Imprese Mandanti */}
          <section className="bg-white rounded-xl shadow-sm p-6 sm:p-8">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-[#3AAFA9]/10 rounded-lg flex items-center justify-center">
                <Users className="text-[#3AAFA9]" size={20} />
              </div>
              <h2 className="text-xl font-bold text-[#3AAFA9]">4. Elenco Imprese Mandanti</h2>
            </div>
            
            <p className="text-gray-700 mb-4">
              In un'ottica di totale trasparenza, si riporta l'elenco delle Imprese di Assicurazione con cui 
              Assietica intrattiene rapporti d'affari:
            </p>
            
            <div className="grid sm:grid-cols-1 gap-3">
              {impreseMandanti.map((impresa, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-[#3AAFA9] rounded-full mr-3"></div>
                    <span className="text-gray-700 font-medium">{impresa.nome}</span>
                  </div>
                  <span className="text-gray-500 text-sm">{impresa.tipo}</span>
                </div>
              ))}
            </div>
          </section>

          {/* Sezione 5: Whistleblowing */}
          <section className="bg-white rounded-xl shadow-sm p-6 sm:p-8 border-l-4 border-[#9B59B6]">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-[#9B59B6]/10 rounded-lg flex items-center justify-center">
                <AlertTriangle className="text-[#9B59B6]" size={20} />
              </div>
              <div>
                <h2 className="text-xl font-bold text-[#9B59B6]">5. Procedura Whistleblowing</h2>
                <p className="text-sm text-gray-500">Segnalazioni Interne - D.Lgs. 24/2023</p>
              </div>
            </div>
            
            <p className="text-gray-700 mb-4">
              Assietica, nel rispetto del <strong>D.Lgs. 24/2023</strong>, ha adottato un canale di segnalazione interna 
              per garantire la riservatezza e la protezione dei soggetti che segnalano violazioni di disposizioni 
              normative nazionali o dell'Unione Europea.
            </p>
            
            <div className="bg-[#9B59B6]/5 border border-[#9B59B6]/20 rounded-lg p-4">
              <p className="text-gray-700">
                <strong>Gestore delle Segnalazioni:</strong><br />
                Assietica ha nominato come Gestore esterno lo <strong>SNA Nazionale</strong> (Sindacato Nazionale Agenti) 
                nella persona dell'<strong>Avvocato Gianluigi GRIECO</strong>.
              </p>
            </div>
          </section>

          {/* Sezione 6: Documentazione Precontrattuale */}
          <section className="bg-white rounded-xl shadow-sm p-6 sm:p-8">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-[#2B7A9F]/10 rounded-lg flex items-center justify-center">
                <FileText className="text-[#2B7A9F]" size={20} />
              </div>
              <h2 className="text-xl font-bold text-[#2B7A9F]">6. Documentazione Precontrattuale</h2>
            </div>
            
            <p className="text-gray-700 mb-4">
              Per ogni proposta assicurativa, Assietica provvede alla consegna (tramite modalita elettroniche 
              autorizzate dal cliente) della seguente documentazione:
            </p>
            
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start">
                <div className="w-2 h-2 bg-[#2B7A9F] rounded-full mr-3 mt-2"></div>
                <span><strong>Allegato 3:</strong> Modulo Unico Precontrattuale (MUP) per i prodotti assicurativi non d'investimento</span>
              </li>
              <li className="flex items-start">
                <div className="w-2 h-2 bg-[#2B7A9F] rounded-full mr-3 mt-2"></div>
                <span><strong>DIP:</strong> Documento Informativo Prodotto redatto dall'Impresa di Assicurazione</span>
              </li>
              <li className="flex items-start">
                <div className="w-2 h-2 bg-[#2B7A9F] rounded-full mr-3 mt-2"></div>
                <span><strong>DIP Aggiuntivo:</strong> Documento Informativo Prodotto Aggiuntivo specifico del prodotto</span>
              </li>
              <li className="flex items-start">
                <div className="w-2 h-2 bg-[#2B7A9F] rounded-full mr-3 mt-2"></div>
                <span><strong>Set Informativo:</strong> Condizioni contrattuali complete</span>
              </li>
            </ul>
            
            <div className="mt-4 p-4 bg-[#2B7A9F]/5 rounded-lg">
              <p className="text-sm text-gray-600">
                Il documento puo essere fornito con modalita non cartacea se appropriato rispetto alle modalita 
                di distribuzione e se il contraente lo consente (art. 120-quater del CAP).
              </p>
            </div>
          </section>

        </div>

        {/* Contact Box */}
        <div className="mt-10 bg-[#2B7A9F]/5 rounded-xl p-6 border border-[#2B7A9F]/20">
          <h3 className="font-semibold text-gray-800 mb-3">Hai bisogno di assistenza?</h3>
          <div className="flex flex-wrap gap-4 text-sm">
            <a href="tel:+390785747193" className="text-[#2B7A9F] hover:underline flex items-center">
              <Phone size={16} className="mr-1" /> 0785 747193
            </a>
            <a href="mailto:agenzia@assietica.it" className="text-[#2B7A9F] hover:underline flex items-center">
              <Mail size={16} className="mr-1" /> agenzia@assietica.it
            </a>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#17536B] text-white py-6 mt-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-sm text-white/70">
            © {new Date().getFullYear()} Assietica Societa Cooperativa. Tutti i diritti riservati.
          </p>
          <p className="text-xs text-white/50 mt-2">
            Intermediario iscritto al RUI A000480096 - Vigilanza IVASS
          </p>
        </div>
      </footer>
    </div>
  );
};

export default TrasparenzaReclami;
